const initialState = {
  loading: false,
  detail: null,
  error: null,
};

export default function portalReducer(state = initialState, action) {
  switch (action.type) {
    case "PORTAL_DETAIL_LOADING":
      return { ...state, loading: true };
    case "PORTAL_DETAIL_SUCCESS":
      return { ...state, loading: false, detail: action.payload };
    case "PORTAL_DETAIL_ERROR":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
